<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import { getCookie ,removeCookie} from "@/store/cookies";
  import utils from "@/utils";
  import global from "@/config/index.js";
  import logoutService from "@/services/bylBaseCenter/user/logout";
import {
  clearAll,
  listeningToUserActions,
} from "@/utils/listeningToUserActions";
function dispatchLogout() {
 removeCookie(VueApp.$vars.TOKEN_KEY);
  removeCookie(VueApp.$vars.USERID_KEY);
  removeCookie("org");
  removeCookie("query_record");
  removeCookie("ifrm_031");
  logoutService.logout().then((r) => {
      if (window.location.hostname == "localhost") {
      window.location.href = "http://localhost:8080";
    } else {
      window.location.href = "https://inesajxjy.byl.sh.cn";
    }
      // window.location.href = 'https://inesajxjy.byl.sh.cn'
  });
  // var isIP = utils.isIP(window.location.hostname);
  // if (!isIP) {
  //   // 域名/localhost的情况
  //   if (window.location.hostname == "localhost") {
  //     window.location.href = "http://localhost:8080";
  //   } else {
  //     window.location.href =
  //       "http://" + global.DEFAULT_DOMAIN + ":" + global.webport;
  //   }
  // } else {
  //   if (global.DEPLOY) {
  //     window.location.href = "http://" + window.location.hostname;
  //   } else {
  //     window.location.href =
  //       "http://" + window.location.hostname + ":" + global.webport;
  //   }
  // }
}
export default {
  name: "app",
  created() {
    if (getCookie("inesajxjy-token")) {
      listeningToUserActions(dispatchLogout); // 监听用户是否操作
    }
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="scss">
@import "./assets/scss/input";
@import "./assets/scss/admin";
@import "./assets/scss/style";
@import "./assets/scss/main";
@import "./assets/scss/zhicheng.scss";
@import "./assets/scss/onsite.scss";
@import "./assets/scss/member";
@import "./assets/scss/main_mine";
@import "./assets/scss/main_mine_byl.scss";
@import "./assets/scss/main_mine_continueEdu.scss";
@import "./assets/scss/main_mine_entrain.scss";
@import "./assets/css/projcommon.css";
</style>



// WEBPACK FOOTER //
// src/App.vue